import {
    FETCH_CREATE_UNIVERSITIES_REQUEST,
    FETCH_CREATE_UNIVERSITIES_SUCCESS,
    FETCH_CREATE_UNIVERSITIES_FAILURE,
} from '../../actions/universities/create-university-action';

const initialState = {
    createdUniversity: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateUniversityReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_UNIVERSITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_UNIVERSITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdSearcher: { ...action.payload[0] },
            };
        case FETCH_CREATE_UNIVERSITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateUniversityReducer;